module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage.0f9ca0e0.png";